import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import type { BaseError } from '@utils/types/shared/base.ts';
import type {
  StartOAuthPayload,
  StartOAuthResponse
} from '@utils/types/connections/connection.ts';

async function startConnection(
  payload: StartOAuthPayload
): Promise<StartOAuthResponse> {
  const { data } = await Axios.post<StartOAuthResponse>(
    POST_URL().startConnection,
    payload
  );
  return data;
}

export function useStartConnection() {
  return useMutation<
    StartOAuthResponse,
    AxiosError<BaseError>,
    StartOAuthPayload
  >(startConnection, { useErrorBoundary: false });
}
